import React from "react";
import iconTrofeuOuro from "../imagem/iconTrofeuOuro.svg";
import iconTrofeuPrata from "../imagem/iconTrofeuPrata.svg";
import iconTrofeuBronze from "../imagem/iconTrofeuBronze.svg";

export default function MeuRanking({ lugar, nome, pontuacao, avatar }) {

  const formatarLugar = () => {
    if (!lugar || typeof lugar !== "string") return lugar;

    const numero = lugar.match(/\d+/); 
    return numero ? numero[0] : lugar;
  };

  const lugarFormatado = formatarLugar();

  const getTrophy = () => {
    if (lugarFormatado === "1") return <img src={iconTrofeuOuro} style={styles.trofeu} />;
    if (lugarFormatado === "2") return <img src={iconTrofeuPrata} style={styles.trofeu} />;
    if (lugarFormatado === "3") return <img src={iconTrofeuBronze}  style={styles.trofeu} />;
    return null;
  };

  if (!lugar) {
    return (
      <div style={styles.container}>
        <h3 style={styles.titulo}>Minha posição no ranking</h3>
        <div style={styles.card}>
          <p style={styles.nome}>Carregando ranking...</p>
        </div>
      </div>
    );
  }

  if (lugar === "Sem lugar no ranking") {
    return (
      <div style={styles.container}>
        <h3 style={styles.titulo}>Minha posição no ranking</h3>
        <div style={styles.card}>
          <p style={styles.nome}>Sem lugar no ranking</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h3 style={styles.titulo}>Minha posição no ranking</h3>

      <div style={styles.card}>
        <div style={styles.posicao}>
          <span>{lugarFormatado}º</span>
        </div>

        {getTrophy()}

        <img
          src={avatar}
          alt={nome}
          style={styles.avatar}
        />

        <span style={styles.nome}>{nome}</span>
        <span style={styles.xp}>{pontuacao}</span>
      </div>
    </div>
  );
}

const styles = {
  container: {
    borderRadius: "18px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  titulo: { fontSize: 23 },
  card: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "var(--cor-brancoTabela)",
    borderRadius: "12px",
    padding: "6px 1px",
    width: "100%",
    boxShadow: "0 2px 5px var(--cor-cinzaMargin)",
    marginTop: "20px"
  },
  posicao: {
    backgroundColor: "var(--cor-roxoEscuro)",
    color: "var(--cor-branco)",
    fontWeight: 600,
    fontSize: "0.9rem",
    borderRadius: "8px",
    padding: "10px 10px",
    marginLeft: "10px",
  },
  trofeu: { marginLeft: "8px" },
  avatar: {
    width: "25px",
    height: "25px",
    borderRadius: "100%",
    objectFit: "cover",
    marginLeft: "30px",
  },
  nome: {
    flex: 1,
    color: "var(--cor-pretoApoio)",
    fontWeight: 500,
    fontSize: "0.95rem",
    marginLeft: "11px",
  },
  xp: {
    fontWeight: 600,
    color: "var(--cor-pretoApoio)",
    marginRight: "13px",
  },
};
